<template>
  <img
    v-if="src"
    :src="src"
    class="flex-shrink-0"
    @error="e => $emit('error', e)"
  />
  <span
    class="skeleton skeleton--image flex-shrink-0"
    :class="skeletonClass"
    v-else
  />
</template>

<script>
export default {
  name: "SkeletonLine",
  props: {
    src: String,
    variant: String,
  },
  computed: {
    skeletonClass() {
      return this.variant === "light" ? "skeleton--light" : "";
    },
  },
};
</script>

<style lang="scss">
@keyframes pulse {
  0% {
    background-position: 0% 0%;
  }

  100% {
    background-position: -135% 0%;
  }
}

.skeleton--image {
  opacity: 0.4;

  &::before {
    content: "\00a0";
    visibility: hidden;
  }
}
</style>
